export default {
  name: 'ProductCommentReply',
  props: {
    reply: Object,
  },
}
